"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var td_constants_1 = require("@core/data-layer/shared/models/td.constants");
function addBooleanPropToParams(property, params) {
    params[property.urlParamName] = property.value.toString();
    return params;
}
exports.addBooleanPropToParams = addBooleanPropToParams;
function extractBooleanFromParams(paramName, params) {
    return params[td_constants_1.TD_QUERY_PARAMS[paramName]] ? JSON.parse(params[td_constants_1.TD_QUERY_PARAMS[paramName]]) : undefined;
}
exports.extractBooleanFromParams = extractBooleanFromParams;
